import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";

import Sheet from "components/sheet/Sheet";
import Input from "components/form/input/Input";



type NewCustomerCreditModalProps = {
  customerId: number;
  isVisible: boolean;
  onClose: () => void;
  onOk: (title: string) => void;
};

export default function NewCustomerCreditModal(props: NewCustomerCreditModalProps) {
  const { isVisible, onClose } = props;

  const { t } = useTranslation();


  const [customerCredit, setHouseAccount] = useState({
    title: "",
  });

  function handleCloseModal() {
    setHouseAccount(prevState => ({
      ...prevState,
      title: "",
    }));

    onClose();
  }

  function handleChange(event: any) {
    const id = event?.target?.id;
    const value = event?.target?.value;

    if (id === undefined || value === undefined) {
      return;
    }

    setHouseAccount(prevState => ({ ...prevState, [id]: value }));
  }

  function handleOnOk(title: string) {
    props.onOk(title);
    handleCloseModal();
  }

  return (
    <Sheet
      open={isVisible}
      size="medium"
      height="flexible"
      closable
      title={t("New Credit Book")}
      onCancel={() => handleCloseModal()}
      onOk={() => handleOnOk(customerCredit.title)}
      cancelText={t("Cancel")}
      okText={t("Create Credit Book")}
      okDisabled={customerCredit.title === "" ? true : false}
    >
      <Form>
        <FormLayout>
          <FormLayout.Group>
            <Input
              value={customerCredit.title}
              label={t("Title")}
              id="title"
              placeholder={t("Title")}
              onChange={handleChange}
            />
          </FormLayout.Group>
        </FormLayout>
      </Form>
    </Sheet>
  );
}
